import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
export const calculateViewBoxFitToArtBoard = (self, config) => {
  const art_board = self._getArtBoardThrowable();
  const view_port = self._getViewPortThrowable();
  const view_box = self._getViewBoxThrowable();
  const view_port_width = view_port.getWidth();
  const view_port_height = view_port.getHeight();
  const view_port_padding_top = config?.padding_in_vcs?.top ?? 0;
  const view_port_padding_right = config?.padding_in_vcs?.right ?? 0;
  const view_port_padding_bottom = config?.padding_in_vcs?.bottom ?? 0;
  const view_port_padding_left = config?.padding_in_vcs?.left ?? 0;
  return view_box.calculateFitTo({
    user_coordinate_system_area: {
      x: 0,
      y: 0,
      width: art_board.getWidth(),
      height: art_board.getHeight(),
    },
    viewport_coordinate_system_area: {
      x: view_port_padding_left,
      y: view_port_padding_top,
      width: view_port_width - view_port_padding_left - view_port_padding_right,
      height:
        view_port_height - view_port_padding_top - view_port_padding_bottom,
    },
    view_port: {
      width: view_port_width,
      height: view_port_height,
    },
    vertical_align: "top",
  });
};
